// components/layout/TopBar.jsx
// 顶栏: 品牌标 / 面包屑 / 全局搜索 / 全局统计 / 操作图标

import { useSolPred } from '../../hooks/useSolPredStore';

export default function TopBar() {
  const { selectedSystem, activeTab, tabs, stats } = useSolPred();
  const currentTab = tabs.find(t => t.id === activeTab);

  return (
    <div className="topbar">
      <div className="brand">
        <div className="brand-mark">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path d="M12 2L20 7V17L12 22L4 17V7L12 2Z" stroke="white" strokeWidth="1.6" strokeLinejoin="round"/>
            <circle cx="12" cy="12" r="3" fill="white" />
          </svg>
        </div>
        <div className="brand-text">
          <div className="brand-name">SolPred</div>
          <div className="brand-sub">Solubility Intelligence Platform</div>
        </div>
      </div>

      <div className="breadcrumb">
        <span>体系</span>
        <span className="sep">/</span>
        <strong className="formula">{selectedSystem.components.join(' – ')}</strong>
        <span className="sep">/</span>
        <span>{currentTab?.label}</span>
      </div>

      <div className="topbar-spacer" />

      <div className="global-search">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" strokeWidth="2">
          <circle cx="11" cy="11" r="7" />
          <path d="M21 21l-4-4" strokeLinecap="round" />
        </svg>
        <input placeholder="搜索体系 / CAS / 文献 / 模型 ..." />
        <span className="kbd">⌘K</span>
      </div>

      <div className="top-stat">
        <span className="top-stat-label">数据库</span>
        <span className="top-stat-value">80,247</span>
      </div>
      <div className="top-stat">
        <span className="top-stat-label">体系</span>
        <span className="top-stat-value accent">{stats.totalSystems}</span>
      </div>
      <div className="top-stat">
        <span className="top-stat-label">已训练</span>
        <span className="top-stat-value success">{stats.trained}</span>
      </div>
      <div className="top-stat">
        <span className="top-stat-label">平均 R²</span>
        <span className="top-stat-value">{stats.avgR2}</span>
      </div>

      <div className="icon-btn" title="文档">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" />
          <path d="M14 2v6h6M16 13H8M16 17H8M10 9H8" strokeLinecap="round" />
        </svg>
      </div>
      <div className="icon-btn" title="通知">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9M13.7 21a2 2 0 01-3.4 0" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </div>
      <div className="avatar">YJ</div>
    </div>
  );
}
